import React from 'react';
// Modules
import { MdOutlineScreenSearchDesktop } from 'react-icons/md';

export const NoData = () => {
  return (
    <div className="nodata">
      <div className="nodata__content">
        <MdOutlineScreenSearchDesktop />
        <label>Não foram encontrados resultados</label>
      </div>
    </div>
  );
};
